import Bonus from './scenes/Bonus';
import DoorScene from './scenes/DoorScene';
import Game from './scenes/Game';
import LevelSelect from './scenes/LevelSelect';
import MainMenu from './scenes/MainMenu';
import MenuPopup from './scenes/MenuPopup';
import Win from './scenes/Win';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [MainMenu, DoorScene, LevelSelect, Game, MenuPopup, Bonus, Win],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: DoorScene.KEY, // Frist Scene is determined in DoorScene.js Change the Key there

  countBy: 2,
  indexStart: 0,
  curLevel: 1,
  meteorsDestroyed: 0,
  instructionsDisplayed: false,
  config: null,
};